import React from 'react';
import './App.css';
import Header from './Header';
import ImageSlider from './ImageSlider';
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import HomePage from './Components/HomePage';
import Ministries from './Components/Ministries';
import Sermons from './Components/Sermons';
import Footer from './Components/Footer';
import About from './Components/About';

function App() {
  return (
    <div className="app">
      <Router>

        <Header/>

        <Switch>
          
          <Route exact path="/">
             <ImageSlider/>
             <HomePage/>
          </Route>
          <Route path="/about">
            <About/>
          </Route> 
         
          <Route path="/ministries">
             <Ministries/>
          </Route>
          <Route path="/sermons">
            <Sermons/>
          </Route>  
 
        </Switch>
        
        <Footer/>
        
      </Router>

    </div>
  );
}

export default App;
